import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import EntityInfoDisplay from "../EntityInfoDisplay/EntityInfoDisplay";
import GameOutcomeDisplay from "../GameOutcomeDisplay/GameOutcomeDisplay";
import { Game } from "../../game_entities/Game/Game";
import { animateCanvas } from "../../helpers/animate_canvas";
import "./GameCanvas.css";
import { saveGameState } from "../../redux/actions/actions";

const GameCanvas = ({ width, height }) => {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const isPaused = useSelector((state) => state.game.isPaused);
  const isGameStarted = useSelector((state) => state.game.isGameStarted);
  const isGameOver = useSelector((state) => state.game.gameOver);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let game = null;

    if(ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    const startGame = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      game = new Game(ctx, width, height, dispatch);
      game.setupEventListeners();

      animateCanvas(canvas, game, ctx, 0, animateCanvas);
      dispatch(saveGameState({ gameState: game }));
      game.startCountdown();
    };

    if (isGameStarted) startGame();
  }, [width, height, dispatch, isGameStarted, isPaused]);

  return (
    <div>
      {!isGameStarted && <EntityInfoDisplay />}
      {isGameStarted && isGameOver && <GameOutcomeDisplay />}
      <canvas
        ref={canvasRef}
        className="canvas1"
        width={width}
        height={height}
        data-testid="canvas-board"
      />
    </div>
  );
};

export default GameCanvas;
